import { HttpClient } from 'api/HttpClient';
import { Lender } from 'enums/ApplicationsVariables';

export interface OfferDto {
  lender: Lender;
  loanAmount: number;
  grossLoan: number;
  fixedRate: number;
  apr: number;
  termYears: string;
  monthlyPayment: number;
  oneTimeFeePercentage: number;
}

export interface AcceptOfferDto {
  offerUrl?: string;
}

export interface DeclineOfferDto {
  applicationId: string;
  isWithdrawn: boolean;
}

export default class OffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/offers' || '');
  }

  public async getOffers(applicationId: string): Promise<OfferDto[]> {
    return this.instance.get(`?applicationId=${applicationId}`).then((response) => response.data);
  }

  public async acceptOffer(applicationId: string): Promise<AcceptOfferDto> {
    return this.instance.post('', { applicationId: applicationId }).then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferDto): Promise<void> {
    return this.instance.post('/decline', declineOfferDto).then((response) => response.data);
  }
}

export const offersApi = new OffersApi();
